exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".totals{text-align:right;height:27px;font-family:OpenSans-Regular,Open Sans,sans-serif;padding:4px 4px 4px 4px;margin-right:25px}.bold,.totals{font-size:16px}.bold{font-weight:700}.button-vendors{margin-top:20px}", "", {"version":3,"sources":["/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/payment/vendors-total-add-payment/vendors-total-add-payment.component.css"],"names":[],"mappings":"AACA,QACE,iBAAkB,YACL,kDAC4C,wBAChC,iBACN,CAEpB,cADC,cAAgB,CAIlB,MAEE,eAAiB,CAClB,gBAGC,eAAiB,CAClB","file":"vendors-total-add-payment.component.css","sourcesContent":["\n.totals {\n  text-align: right;\n  height: 27px;\n  font-family: \"OpenSans-Regular\", \"Open Sans\", sans-serif;\n  padding: 4px 4px 4px 4px; \n  margin-right: 25px;\n  font-size: 16px;    \n}\n\n\n.bold {\n  font-size: 16px;\n  font-weight:bold;\n}\n\n.button-vendors {\n  margin-top: 20px;\n}\n"],"sourceRoot":""}]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/payment/vendors-total-add-payment/vendors-total-add-payment.component.css
// module id = wagN
// module chunks = 0